module.exports = __webpack_public_path__ + "img/组 6610.ce340d0c.png";